
function InfractionPenaltyNotification() {
  this.queueNoty = 'infractionPenaltyNotification';
}

InfractionPenaltyNotification.prototype.showNotification = function (data) {
  if (!data) {
    return;
  }

  // Trabalha os dados vindo do Socket
  infractionPenalty = JSON.parse(data);

  var textNoty;
  if (infractionPenalty.reference_id) {
    textNoty = i18n.punishment_infraction_message
      .replace('{nickname}', infractionPenalty.nick)
      .replace('{minutes}', infractionPenalty.minutes)
      .replace('{reason}', infractionPenalty.reason)
      .replace('{reference_id}', infractionPenalty.reference_id);
  } else {
    textNoty = i18n.punishment_infraction_message_simple
      .replace('{nickname}', infractionPenalty.nick)
      .replace('{reason}', infractionPenalty.reason)
      .replace('{minutes}', infractionPenalty.minutes);
  }

  // Monta e exibe a notificação de que um player infrator foi punido
  new Noty({
    // Estilos e Configurações
    queue: this.queueNoty,
    type: this.queueNoty,
    timeout: 5000,
    layout: 'topRight',
    animation: {
      open: 'animated fadeInRight',
      close: 'animated fadeOutRight'
    },

    // Conteúdos
    text: textNoty,
    nick: infractionPenalty.nick,
    avatar: infractionPenalty.avatar,
    reputationColor: window.getReputationColor(infractionPenalty.reputation),
    reputationCircle: window.getPlayerReputation(100 - infractionPenalty.reputation),

    // Template
    callbacks: {
      onTemplate: function () {
        var innerHTML = '<div class="notyInfractionPenalty noty_body">';
        innerHTML += '<div class="notyInfractionPenalty__content">';
        innerHTML += '<div class="notyInfractionPenalty__avatar">';
        innerHTML += '<svg viewBox="0 0 42 42">';
        innerHTML += '<circle stroke="' + this.options.reputationColor + '" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke-width="2" />';
        innerHTML += '<circle stroke-dasharray="' + this.options.reputationCircle + '" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#000" stroke-opacity=".7" stroke-width="2" stroke-dashoffset="25"/>';
        innerHTML += '</svg>';
        innerHTML += '<div class="notyInfractionPenalty__avatarImg">';
        innerHTML += '<img src="' + this.options.avatar + '" alt="' + this.options.nick + '" onerror="this.style.display=\'none\'">';
        innerHTML += '</div>';
        innerHTML += '</div>';
        innerHTML += '<div class="notyInfractionPenalty__text"><div>' + this.options.text + '</div></div>';
        innerHTML += '</div>';

        this.barDom.innerHTML = innerHTML;
      }
    }
  }).show();
};

window.infractionPenaltyNotification = new InfractionPenaltyNotification();
